export enum MediaTypes {
  DOCUMENT = 'document',
  AUDIO    = 'audio',
  IMAGE    = 'image',
  VIDEO    = 'video'
}

export enum ImageTypes {
  JPG  = '.jpg',
  JPEG = '.jpeg',
  PNG  = '.png',
}

export enum VideoTypes {
  MP4 = '.mp4',
  GPP = '.3gpp'
}

export enum AudioTypes {
  MP3 = '.mp3',
  OGG = '.ogg',
  OGA = '.oga',
  AAC = '.aac'
}

export enum DocumentTypes {
  PDF  = '.pdf',
  DOCX = '.docx',
  XLSX = '.xlsx'
}